import { Link } from "react-router-dom";

export function AppFooter() {
  return (
    <footer style={st.footer}>
      <p style={st.brand}>
        <Link to="/" style={{ color: "#D4A853", fontWeight: 700, textDecoration: "none" }}>땅</Link>
        <span>신뢰 LandTrust</span>
      </p>
      <p style={st.info}>운영: genomic.cc</p>
      <p style={st.contact}>
        <span>{"\uD83D\uDCDE"} 070-8225-8585</span>
        <span style={st.sep}>|</span>
        <span>{"\u2709\uFE0F"} admin@genomic.cc</span>
      </p>
      <p style={st.links}>
        <Link to="/privacy" style={st.link}>개인정보처리방침</Link>
        <span style={st.sep}>|</span>
        <Link to="/terms" style={st.link}>이용약관</Link>
      </p>
      <p style={st.copy}>© 2026 LandTrust. All rights reserved.</p>
    </footer>
  );
}

const st: Record<string, React.CSSProperties> = {
  footer: {
    background: "var(--bg-card)",
    borderTop: "1px solid var(--border-light)",
    padding: "32px 20px",
    textAlign: "center" as const,
    marginTop: "auto",
  },
  brand: {
    fontSize: 18,
    fontWeight: 700,
    color: "var(--text-primary)",
    margin: "0 0 8px",
    letterSpacing: "-0.3px",
  },
  info: {
    fontSize: 13,
    color: "var(--text-muted)",
    margin: "0 0 4px",
  },
  contact: {
    fontSize: 13,
    color: "var(--text-muted)",
    margin: "0 0 4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0,
    flexWrap: "wrap" as const,
  },
  links: {
    fontSize: 12,
    color: "var(--text-muted)",
    margin: "0 0 4px",
  },
  link: {
    color: "var(--text-muted)",
    textDecoration: "none",
  },
  sep: {
    margin: "0 6px",
    color: "var(--border-medium)",
  },
  copy: {
    fontSize: 12,
    color: "var(--text-muted)",
    margin: 0,
  },
};
